import Loading from "@fuse/components/FuseLoadable/Loading";
import _ from "@lodash";
import { AppBar, DialogContent, IconButton, Toolbar, Typography } from "@material-ui/core";
import Constante from "Constante.json";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import MarketplaceButton from "app/Marketplace/MarketplaceButton";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import md5 from "js-md5";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import ConfirmacaoApp from "../Confirmacao/ConfirmacaoApp";
import XAPPDialog from "../Dialog/XAPPDialog";
import * as Actions from "./Store/Actions/MemedActions";
import reducer from "./Store/Reducers/MemedReducer";
import XAPPButton from "../Button/XAPPButton";

class Memed extends XAPPComponent {
   state = {
      open: false,
   };

   componentDidMount() {
      const { getToken, xappRouteParams } = this.props;
      getToken(xappRouteParams);
   }

   componentDidUpdate(prevProps, prevState) {
      const { token = null } = this.props;
      const form = this.state;
      if (!_.isNull(token) && ((!prevState.open && form.open) || (form.open && _.isNull(prevProps.token)))) {
         this.initMemed();
      }
   }

   componentWillUnmount() {
      delete window.MdHub;
      if (!_.isNull(document.getElementById("scriptMemed"))) {
         document.getElementById("scriptMemed").remove();
      }
      if (!_.isNull(document.getElementById("memed-auto-generated"))) {
         document.getElementById("memed-auto-generated").remove();
      }
      this.props.clearToken();
   }

   initMemed() {
      const { theme, token, constantes } = this.props;
      const AThis = this;
      var script = document.createElement("script");
      script.setAttribute("id", "scriptMemed");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("data-color", theme.palette.primary.main);
      script.setAttribute("data-token", token);
      script.src = constantes["MEMED_SCRIPT_URL"];

      script.onload = function () {
         AThis.initEventsMemed(AThis);
      };
      document.head.appendChild(script);
   }

   save = (_AValue) => {
      const { saveDocumentoMemed, xappRouteParams, idfuncionalidade, token, data, callbackSave } = this.props;
      saveDocumentoMemed({
         id: _AValue.prescricao.id,
         idfuncionalidade: idfuncionalidade,
         idpessoaformulario: data.idpessoaformulario,
         value: _AValue,
         token: token
      }, xappRouteParams, callbackSave);
   };

   initEventsMemed(_AThis) {
      window.MdSinapsePrescricao.event.add("core:moduleInit",
         function moduleInitHandler(module) {
            window.MdSinapsePrescricao.command.send("hub", "core:setDictionary", {});

            if (module.name === "plataforma.prescricao") {
               window.MdHub.event.add("prescricaoImpressa",
                  function (prescriptionData) {
                     _AThis.save(prescriptionData);
                  }
               );

               window.MdHub.event.add("prescricaoExcluida",
                  function (idPrescricao) {
                     _AThis.props.callbackRemove(md5("" + idPrescricao));
                  }
               );

               window.MdHub.command.send("plataforma.prescricao", "setFeatureToggle",
                  { deletePatient: false, removePatient: false, editPatient: false }
               );

               window.MdHub.command.send("plataforma.prescricao", "setPaciente", {
                  nome: _AThis.props.data.nome,
                  nome_social: _AThis.props.data.nomesocial,
                  endereco: _AThis.props.data.logradouro1 + ", " + _AThis.props.data.numero1 + " - " + _AThis.props.data.bairro1,
                  cidade: _AThis.props.data.cidade1_nome,
                  cpf: _AThis.props.data.documentoprimario,
                  telefone: _AThis.props.data.celular,
                  email: _AThis.props.data.email,
                  data_nascimento: _AThis.props.data.nascimentoabertura,
                  idExterno: _AThis.props.data.idpessoaformulario,
               })
                  .then(function success() {
                     const ADadosEmpresa = _AThis.props.sistemas[_AThis.props.xappRouteParams.empresa].dados;
                     window.MdHub.command.send(
                        "plataforma.prescricao",
                        "setWorkplace",
                        {
                           city: ADadosEmpresa.cidade_nome,
                           state: ADadosEmpresa.cidade_nome,
                           local_name: ADadosEmpresa.nome,
                           address: `${ADadosEmpresa.logradouro}, ${ADadosEmpresa.numero} - ${ADadosEmpresa.bairro}`,
                           phone: ADadosEmpresa.fone,
                        }
                     );

                     window.MdHub.command.send(
                        "plataforma.prescricao",
                        "setAdditionalData",
                        {
                           footer: `${ADadosEmpresa.logradouro}, ${ADadosEmpresa.numero} - ${ADadosEmpresa.bairro} | ${ADadosEmpresa.contato}`,
                           atendimento: _AThis.props.idfuncionalidade,
                        }
                     );

                     // Exibe a UI da Memed
                     window.MdHub.module.show(module.name);
                     _AThis.setState(_.set({ ..._AThis.state }, "open", false));
                  });
            }
         }
      );
   }

   render() {
      const { token = null, tokenPendente, getToken, xappRouteParams } = this.props;
      const form = this.state;

      return (
         <React.Fragment>
            {_.isNull(token) && tokenPendente &&
               <MarketplaceButton
                  id="ReceituarioMemed"
                  xappRouteParams={xappRouteParams}
                  tipo={Constante.memed}
                  callback={() => {
                     getToken(xappRouteParams);
                     this.setState(_.set({ ...this.state }, "open", true));
                  }}
               >
                  <XAPPButton
                     tooltip={{ "title": "Configurar integração", "placement": "top" }}
                     type="Icon"
                     className="hidden"
                     onClick={() => { }}
                  >
                     <img
                        src="/assets/images/memed.png"
                        width={20}
                        height={20}
                     />
                    
                  </XAPPButton>
               </MarketplaceButton>
            }
            {!_.isNull(token) && (
               <ConfirmacaoApp
                  tooltip={{ "title": "Prescrição memed", "placement": "top" }}
                  id="ReceituarioMemed"
                  type="icon"
                  checkBypass={() => {
                     const iframe = document.getElementById("iframe");
                     if (!_.isNull(iframe)) {
                        return !iframe.contentWindow.checkFormPreenchido();
                     }
                  }}
                  onConfirmation={() => {
                     if (!_.isUndefined(window.MdHub)) {
                        window.MdHub.module.show("plataforma.prescricao");
                     } else {
                        this.setState(_.set({ ...this.state }, "open", true));
                     }
                  }}
                  mensagem={"Identificamos informações que não foram salvas no formulário. Após a emissão pela MEMED estes dados serão perdidos. Deseja continuar?"}
                  className="hidden"
               >
                  <img
                     src="/assets/images/memed.png"
                     width={20}
                     height={20}
                  />
               </ConfirmacaoApp>
            )}
            <XAPPDialog
               id="Memed"
               open={form.open}
               onClose={() => this.setState(_.set({ ...this.state }, "open", false))}
               maxWidth="sm"
               fullWidth
            >
               <AppBar position="static" elevation={1}>
                  <Toolbar className="flex w-full min-h-0">
                     <Typography variant="subtitle1 text-white">
                        {"Integração Memed"}
                     </Typography>
                     <div style={{ flex: 1 }} />
                     <IconButton
                        key="close"
                        aria-label="Close"
                        className="p-6"
                        onClick={() => this.setState(_.set({ ...this.state }, "open", false))}
                     >
                        <MdClose className="text-20 text-white" />
                     </IconButton>
                  </Toolbar>
               </AppBar>
               <DialogContent className="p-52">
                  <Loading pastDelay={true} />
               </DialogContent>
            </XAPPDialog>
         </React.Fragment >
      );
   }
}

function mapDispatchToProps(dispatch) {
   return bindActionCreators({
      getToken: Actions.getToken,
      saveDocumentoMemed: Actions.saveDocumentoMemed,
      clearToken: Actions.clearToken,
      clearPDF: Actions.clearPDF,
      showMessage: AppActions.showMessage,
   }, dispatch);
}

function mapStateToProps({ Memed, auth, fuse }) {
   return {
      token: Memed.token,
      pdf: Memed.pdf,
      tokenPendente: Memed.tokenPendente,
      user: auth.user.data,
      theme: fuse.settings.mainTheme,
      sistemas: auth.user.data.settings.sistemas,
      constantes: auth.user.data.settings.constantes,
   };
}

export default withReducer("Memed", reducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(Memed)));
